import React from "react";
import { Container } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { AiOutlineDownload } from "react-icons/ai";
import Particle from "../../Particle";
// import pdf from "../../assets/Prashant-Malviya-Resume.pdf";

function Resume() {
  return (
    <div>
      <section className="home-section" style={{ position: "relative", zIndex: 1 }}>
        <Container fluid id="home">
          {/* Ensure Particle does not block interactions */}
          <Particle style={{ zIndex: 0 }} />
          <Container className="home-content">
            {/* Heading Section */}
            <div
              className="d-flex justify-content-center relative bottom-5"
              width="100%"
              style={{
                backgroundColor: "#fbd9ad",
                zIndex: 2, 
                position: "relative",
              }}
            >
              <h1 style={{ color: "rgb(134 61 176)" }}>RESUME</h1>
            </div>

            {/* Download Button */}
            <div
              className="d-flex justify-content-center mt-4"
              style={{
                position: "relative",
                zIndex: 2, // Ensure button is clickable
              }}
            >
              <Button variant="primary" href="#" target="_blank" download="Prashant-Malviya-Resume.pdf">
                <AiOutlineDownload />
                &nbsp;Download Resume
              </Button>
            </div>

            {/* Resume Viewer */}
            <div
              className="resume d-flex justify-content-center mt-4"
              style={{
                position: "relative",
                zIndex: 2,
              }}
            >
              {/* <iframe
                src={pdf}
                width="62%"
                height="900px"
                style={{
                  border: "none",
                  zIndex: 2,
                }}
                title="Resume"
              ></iframe> */}
            </div>
          </Container>
        </Container>
      </section>
    </div>
  );
}

export default Resume;
